import axios from "axios";

import queryString from "@/utils/queryString";
import { headers, ledgerServiceUrl } from "../../config";

export function searchDimensionByNameOrCode(payload) {
    let query = queryString(payload);
    return axios.get(`${ledgerServiceUrl}/dimension-search?${query}`, { headers: headers() });
}

export function getDimensionsIn(ids) {
    let params = { in: ids };
    return axios.get(`${ledgerServiceUrl}/dimension-search`, { headers: headers(), params });
}

export function getDimensionById({id}) {
    return axios.get(`${ledgerServiceUrl}/dimensions/${id}`, { headers: headers() });
}

export function getChart()
{
    return axios.get(`${ledgerServiceUrl}/dimension-chart`, { headers: headers() });
}
